import styled from "styled-components";
import type { GlobalToken } from "antd";

export interface TokenProps {
  $token: GlobalToken;
}

export const ChooseAnotherLink = styled.button<TokenProps>`
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: ${({ $token }) => $token.fontSize}px;
  font-weight: 600;
  color: ${({ $token }) => $token.colorTextSecondary};

  &:hover {
    color: ${({ $token }) => $token.colorPrimary};
  }
`;
